/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */
import * as References from './PersonalizationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['queryType', 'search', 'language', 'collectionId', 'filter', 'sorts', 'offset', 'length', 'suggestionSectionFilter', 'rankerId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#autocomplete
 */
export const AUTOCOMPLETE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_autocomplete';
export const AUTOCOMPLETE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: AUTOCOMPLETE_QUERY_FIELD_NAME,
  args: ['queryTerm', 'language', 'fallbackLanguage', 'limit', 'useSpellingCorrections', 'resultTypes', 'productTypes', 'rankerId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.autocompleteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSections
 */
export const GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSections';
export const GET_SUGGESTION_SECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME,
  args: ['maximumSections', 'language', 'minimumSectionCardCount', 'maximumSectionCardCount', 'contexts', 'productTypes'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSuggestionSectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSectionsByType
 */
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSectionsByType';
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME,
  args: ['sectionTypes', 'language', 'minimumSectionCardCount', 'maximumSectionCardCount', 'contexts', 'productTypes'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSuggestionSectionsByTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#searchAssets
 */
export const SEARCH_ASSETS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_searchAssets';
export const SEARCH_ASSETS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_ASSETS_QUERY_FIELD_NAME,
  args: ['language', 'search', 'nameSearch', 'offeringIds', 'offeringTypes', 'tiers', 'absentScopes', 'businessTypes', 'pageTypes', 'pageFeatures', 'contentTypes', 'categories', 'tags', 'providers', 'planType', 'priceRange', 'minOverallRating', 'minReviewCount', 'hasFreeSupport', 'sorts', 'slug', 'length', 'offset', 'portalCompatible', 'searchSource', 'debug'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.searchAssetsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});